import '../../static/icons';
import React from 'react';
import ReactRender from './tools/react-render';
import ClinicFinder from './components/ClinicFinder';
import ClinicAreas from './components/ClinicFinder/ClinicAreas';
import ClinicNextAppointment from './components/ClinicNextAppointment';

export function initEm() {
    // hubspot embed
    const hubspot = document.querySelector('.hs-form-frame');
    if (hubspot) {
        const id = hubspot.dataset.portalId;
        let scriptEle = document.createElement('script');
        scriptEle.setAttribute('src', '//js-eu1.hs-scripts.com/' + id + '.js');
        document.body.appendChild(scriptEle);
        scriptEle = document.createElement('script');
        scriptEle.setAttribute(
            'src',
            'https://js-eu1.hsforms.net/forms/embed/' + id + '.js',
        );
        document.body.appendChild(scriptEle);
    }

    // clinic finder map
    const clinicFinders = document.querySelectorAll(
        '[data-behaviour="clinic-finder"]',
    );

    if (clinicFinders.length > 0) {
        clinicFinders.forEach((clinicFinder) => {
            let config = JSON.parse(
                clinicFinder.getAttribute('data-config') ?? '{}',
            );
            ReactRender(<ClinicFinder config={config} />, clinicFinder);
        });
    }

    // clinic area map
    const clinicAreaMaps = document.querySelectorAll(
        '[data-behaviour="clinic-area-map"]',
    );
    if (clinicAreaMaps.length > 0) {
        clinicAreaMaps.forEach((clinicFinder) => {
            ReactRender(<ClinicAreas areaID={clinicFinder.getAttribute('data-area')} />, clinicFinder);
        });
    }

    // next appointment widget
    const nextClinicAppointments = document.querySelectorAll(
        '[data-behaviour="clinic-next-appointment"]',
    );
    if (nextClinicAppointments.length > 0) {
        nextClinicAppointments.forEach((nextClinicAppointment) => {
            let id = JSON.parse(
                nextClinicAppointment.getAttribute('data-id') ?? null,
            );
            let type = JSON.parse(
                nextClinicAppointment.getAttribute('data-type') ?? null,
            );
            ReactRender(
                <ClinicNextAppointment id={id} type={type} />,
                nextClinicAppointment,
            );
        });
    }
}
